import React from 'react';
import PropTypes from 'prop-types';

function IconX({ stroke, height, style }) {
  return (
    <svg
      height={height}
      stroke={stroke}
      style={style}
      strokeWidth="2"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25 25L13 13M13 13L25 1M13 13L1 1M13 13L1 25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

IconX.propTypes = {
  stroke: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
};

IconX.defaultProps = {
  stroke: 'black',
  height: '12',
  style: null,
};

export default IconX;
